import { call, put } from 'redux-saga/effects'

import config from '../../../config'
import {
  CreateProductInputInterface,
  ProductDetailInterface
} from '../../../interfaces/product'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import {
  createProductSucceed,
  getCompanyProductListSucceed,
  requestFailure
} from '../actions'

export function* createProductSaga(
  productApi: {
    createProduct: (...args: any[]) => any
    getCompanyProductList: (...args: any[]) => any
  },
  {
    payload: productDetail
  }: {
    payload: CreateProductInputInterface
  }
) {
  try {
    yield call(productApi.createProduct, productDetail)
    yield put(createProductSucceed())
    const { data }: { data: ProductDetailInterface } = yield call(
      productApi.getCompanyProductList,
      productDetail.companyId,
      1,
      config.product.limit,
      'createdTime',
      'desc',
      false
    )
    yield put(getCompanyProductListSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
